module.exports = __webpack_public_path__ + "img/ditu.ddccba3e.gif";